import * as React from "react"
import { Product } from "../../interfaces/SaleorTypes"
import Card from "../../atoms/Card"
import H4 from "../../atoms/typography/H4"
import styled from "styled-components"
import Body from "../../atoms/typography/Body"
import TextButton from "../../atoms/buttons/TextButton"
import { theme } from "../../theme"
import { Row } from "react-grid-system"
import { parseDescription, getFormattedPrice } from "../../../utils/cart-helpers"
import H3 from "../../atoms/typography/H3"
import { MediaQuery } from "../../../utils/design-helpers"
import { AddShoppingCartIcon } from "../../atoms/icons/AddShoppingCartIcon"
import { ArrowRight } from "../../atoms/icons/ArrowRight"
import SmallButton from "../../atoms/buttons/SmallButton"

interface Props {
  product: Product
  onClickAddToCart: () => void
  gradient?: string
  onClickReadMore: () => void
}

const Image = styled.img`
  width: 140px;
  height: 140px;
  object-fit: contain;

  ${MediaQuery.XS} {
    width: 140px;
    height: 140px;
  }
`

const CardContainer = styled.div`
  width: 280px;
  margin: 16px;
  height: 416px;

  ${MediaQuery.XS} {
    width: 264px;
    margin: 8px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const StyledCard = styled(Card)<{ gradient: string }>`
  height: 100%;
  border: 3px solid transparent;

  :hover {
    background: ${(props) => `linear-gradient(white, white) padding-box,
      ${props.gradient} border-box`};
    border-radius: 13px;
  }
`

const AccessorySlideCard: React.FunctionComponent<Props> = ({
  product,
  onClickAddToCart,
  gradient = theme.gradients.blue,
  onClickReadMore,
}) => {
  const [added, setAdded] = React.useState(false)

  const onClickAddItemToCart = () => {
    setAdded(true)
    setTimeout(() => setAdded(false), 1500)
    onClickAddToCart()
  }

  return (
    <CardContainer>
      <StyledCard gradient={gradient}>
        <Content>
          <H4 textAlign="center">{product.name}</H4>
          <Row justify="center" align="center">
            <Image src={product.media[0]?.url} alt="Satcube accessory product image" />
          </Row>

          <Body textAlign="center">{parseDescription(product.description)}</Body>

          <Row style={{ padding: "0 15px" }} align="center" justify="between">
            <TextButton title="Read more" icon={<ArrowRight />} onClick={onClickReadMore} />
            <Body>
              {getFormattedPrice(
                product.variants[0].pricing.price.gross.amount,
                product.variants[0].pricing.price.currency,
              )}
            </Body>
          </Row>

          <Row justify="center" nogutter>
            {added ? (
              <H3 color={theme.colors.greenDark}>Added</H3>
            ) : (
              <SmallButton
                title="Add"
                leftIcon={<AddShoppingCartIcon color={theme.colors.greyDark} />}
                onClick={onClickAddItemToCart}
              />
            )}
          </Row>
        </Content>
      </StyledCard>
    </CardContainer>
  )
}

export default AccessorySlideCard
